export const MAINTENANCE_BAR_HEIGHT_CSS_VAR = '--zd-maintenance-bar-height';

export const MAINTENANCE_BAR_ATTRIBUTE = 'data-maintenance-bar';

export const MAINTENANCE_BAR_SIZE = 'var(--zd-maintenance-bar-size)';

export const APP_HEIGHT = 'var(--zd-app-height)';
